import { useEffect } from "react";

export function useFooterDynamicStyles(
  FooterPrimaryColor,
  borderFooterColor,
  heightFooter
) {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--FooterPrimaryColor",
      FooterPrimaryColor
    );

    document.documentElement.style.setProperty(
      "--borderFooterColor",
      borderFooterColor
    );
    document.documentElement.style.setProperty("--heightFooter", heightFooter);
  }, [FooterPrimaryColor, borderFooterColor, heightFooter]);
}
